// export const BASE_URL = 'http://127.0.0.1:8000'
// export const BASE_URL = 'https://backend.jebamegastore.com'
export const BASE_URL = 'https://admin.caremdstore.com'
// export const BASE_URL = ''